module.exports = __webpack_public_path__ + "img/cluster2.2940685.jpg";